import { Component, Input } from '@angular/core';

@Component({
  selector: 'vshcz-empty-state',
  templateUrl: './empty-state.component.html',
  styleUrls: ['./empty-state.component.scss']
})
export class EmptyStateComponent {
  @Input()
  heading: string;

  @Input()
  desc: string;
}
